import { render, staticRenderFns } from "./ForgotPasswordEmail.vue?vue&type=template&id=03ecc010&scoped=true&"
import script from "./ForgotPasswordEmail.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ecc010",
  null
  
)

export default component.exports